import { FOOTER } from "@/constants/testIds";
import { Instagram, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="relative bg-brand-ink text-brand-base"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-3xl text-brand-base">Ferreiro</span>
            <span className="font-serif italic text-2xl text-brand-blush">Play Co.</span>
          </div>
          <p className="mt-5 text-brand-cream/80 font-light max-w-md leading-relaxed">
            Premium soft play rentals for ages 0–5 in Syracuse, NY. Delivery,
            setup and sanitization — always included.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-blush font-semibold mb-4">
            Explore
          </p>
          <ul className="space-y-3 text-sm text-brand-cream/85">
            <li><a className="hover:text-white transition-colors" href="#packages">Packages</a></li>
            <li><a className="hover:text-white transition-colors" href="#addons">Add-ons</a></li>
            <li><a className="hover:text-white transition-colors" href="#how">How it works</a></li>
            <li><a className="hover:text-white transition-colors" href="#quote">Request a quote</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-blush font-semibold mb-4">
            Get in touch
          </p>
          <ul className="space-y-3 text-sm text-brand-cream/85">
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-brand-blush" /> Syracuse, NY
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-brand-blush" />
              <a href="mailto:ferreiroplayco@gmail.com" className="hover:text-white">
                ferreiroplayco@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Instagram className="h-4 w-4 text-brand-blush" />
              <a href="#" className="hover:text-white">@ferreiroplayco</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-brand-cream/60">
          <p>© {new Date().getFullYear()} Ferreiro Play Co. All rights reserved.</p>
          <p>Made with care for little ones in Syracuse.</p>
        </div>
      </div>
    </footer>
  );
}
